export interface Category {
  id: string;
  name: string;
  description?: string | null;
  color?: string | null;
  icon?: string | null;
  user_id: string;
  is_public: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreateCategoryData {
  name: string;
  description?: string;
  color?: string;
  icon?: string;
  is_public?: boolean;
}

export interface UpdateCategoryData {
  name?: string;
  description?: string;
  color?: string;
  icon?: string;
  is_public?: boolean;
}

export interface TodoTemplate {
  id: string;
  name: string;
  description?: string | null;
  category_id: string;
  user_id: string;
  is_public: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreateTodoTemplateData {
  name: string;
  description?: string;
  category_id: string;
  is_public?: boolean;
}

export interface UpdateTodoTemplateData {
  name?: string;
  description?: string;
  category_id?: string;
  is_public?: boolean;
}

export interface TemplateItem {
  id: string;
  template_id: string;
  title: string;
  description?: string | null;
  order_index: number;
  is_completed: boolean;
  priority: 'low' | 'medium' | 'high';
  created_at: string;
  updated_at: string;
}

export interface CreateTemplateItemData {
  template_id: string;
  title: string;
  description?: string;
  order_index: number;
  priority?: 'low' | 'medium' | 'high';
}

export interface UpdateTemplateItemData {
  title?: string;
  description?: string;
  order_index?: number;
  is_completed?: boolean;
  priority?: 'low' | 'medium' | 'high';
}

export interface UserTodoList {
  id: string;
  name: string;
  description?: string | null;
  template_id?: string | null;
  user_id: string;
  created_at: string;
  updated_at: string;
}

export interface CreateUserTodoListData {
  name: string;
  description?: string;
  template_id?: string;
}

export interface UserTodoItem {
  id: string;
  list_id: string;
  title: string;
  description?: string | null;
  order_index: number;
  is_completed: boolean;
  priority: 'low' | 'medium' | 'high';
  due_date?: string | null;
  created_at: string;
  updated_at: string;
}

export interface CreateUserTodoItemData {
  list_id: string;
  title: string;
  description?: string;
  order_index: number;
  priority?: 'low' | 'medium' | 'high';
  due_date?: string;
}

// Enhanced category type with related data
export interface CategoryWithTemplates extends Category {
  templates?: TodoTemplate[];
  templates_count?: number;
}

// Enhanced template type with related data
export interface TodoTemplateWithItems extends TodoTemplate {
  items?: TemplateItem[];
  items_count?: number;
  category?: Category;
}

// Priority color mapping
export const PRIORITY_COLORS = {
  low: '#52c41a',
  medium: '#faad14',
  high: '#ff4d4f',
} as const;

// Default category colors
export const CATEGORY_COLORS = [
  '#1890ff', // Blue
  '#52c41a', // Green
  '#faad14', // Orange
  '#722ed1', // Purple
  '#eb2f96', // Pink
  '#13c2c2', // Cyan
  '#fa541c', // Red-Orange
  '#2f54eb', // Blue-Purple
];

// Default category icons (using emoji for simplicity)
export const CATEGORY_ICONS = [
  '📝', // Notes
  '💼', // Work
  '🏠', // Home
  '🎯', // Goals
  '📚', // Study
  '💪', // Health
  '🛒', // Shopping
  '✈️', // Travel
  '🎨', // Creative
  '💡', // Ideas
];
